import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonService } from '../Services/common.service';

@Component({
    selector: 'app-term-conditions',
    templateUrl: './term-conditions.component.html',
    styleUrls: ['./term-conditions.component.css'],
    standalone: false
})
export class TermConditionsComponent implements OnInit {
  isMobileView = false;
  subscription: Subscription;
  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
  }

  scrollTo(event: Event, id: string): void {
    event.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

}
